"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorCheckoutView = function () {
    var _a = (0, CalculatorContextInterface_1.useCalculatorContext)(), server = _a.server, defaultCurrency = _a.defaultCurrency, game = _a.game;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_hook_form_1.useFormContext)(), register = _c.register, errors = _c.formState.errors;
    return (react_1.default.createElement("div", { className: "__wrap-item __wrap-item-checkout __wrap-item-paddind-24" },
        react_1.default.createElement("button", { type: "submit", disabled: game === undefined, className: "__to-checkout" },
            t("calculator.view.checkout"),
            react_1.default.createElement("img", { src: "/images/app/checkout-button.svg" }))));
};
exports.default = CalculatorCheckoutView;
